import { z } from 'zod';

const PayloadSchema = z.object({
  command: z.string().trim(),
  commandType: z.string().trim(),
  attribute: z.union([
    z.string().trim(),
    z.record(z.string().trim(), z.unknown())
  ])
});

export const ActionPropertyBlockSchema = z.object({
  on: z.string().trim(),
  payload: PayloadSchema
});

export type ActionPropertyBlock = z.infer<typeof ActionPropertyBlockSchema>;
